// extracted by mini-css-extract-plugin
export var icon = "_6r-1";
export var subtext = "_6r-0";